<template>
  <v-dialog
    v-model="localDialog"
    :max-width="maxWidth"
    persistent
    @keydown.esc="cancelDelete"
    @keydown.enter="confirmDelete"
  >
    <v-card class="card">
      <v-card-title class="px-2 py-4">
        <p class="my-auto">{{ $tc("commons.deleteTitle") }} {{ title }}</p>
      </v-card-title>
      <v-card-actions>
        <v-btn class="bt-exit mr-2 mb-2" @click="cancelDelete">{{
          $tc("commons.cancel")
        }}</v-btn>
        <v-btn class="bt-acept mb-2" text @click="confirmDelete">{{
          $tc("commons.accept")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    showDialog: Boolean,
    cancelDelete: Function,
    confirmDelete: Function,
    maxWidth: {
      type: String,
      default: "400px",
    },
  },
  computed: {
    localDialog: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
